import { Blackjack2Record } from '@/models/games/blackjack2';
import { GameState as Blackjack2GameState } from '@/models/games/blackjack2/enums/GameState';
import {
    CarnivalTreasureRecord,
    CarnivalTreasureResult,
    CarnivalTreasureStatistics,
} from '@/models/games/carnivalTreasure';
import {
    FishPrawnCrabGameState,
    FishPrawnCrabRecord,
    FishPrawnCrabResult,
    FishPrawnCrabStatistics,
} from '@/models/games/fishprawncrab';
import {
    ThaiHiLoGameState,
    ThaiHiLoRecord,
    ThaiHiLoResult,
    ThaiHiLoStatistics,
} from '@/models/games/thaiHiLo';
import {
    AndarBaharGameState,
    AndarBaharRecord,
    AndarBaharResult,
    AndarBaharStatistics,
} from '../../../models/games/andarBahar';
import {
    BaccaratGameState,
    BaccaratGoodRoad,
    BaccaratRecord,
    BaccaratResult,
    BaccaratStatistics,
} from '../../../models/games/baccarat';
import {
    BlackjackRecord,
    BlackjackResult,
} from '../../../models/games/blackjack';
import { GameDelay } from '../../../models/games/blackjack/GameDelay';
import {
    DragonTigerGameState,
    DragonTigerRecord,
    DragonTigerResult,
    DragonTigerStatistics,
} from '../../../models/games/dragonTiger';
import { GameState as CommonGameState } from '../../../models/games/enums/GameState';
import { GameType as GameTypeEnum } from '../../../models/games/enums/GameType';
import {
    PokDengRecord,
    PokDengResult,
    PokDengStatistics,
} from '../../../models/games/pokdeng';
import {
    RouletteGameState,
    RouletteRecord,
    RouletteResult,
    RouletteStatistics,
} from '../../../models/games/roulette';
import {
    SedieRecord,
    SedieResult,
    SedieStatistics,
} from '../../../models/games/sedie';
import {
    SicBoGameState,
    SicBoRecord,
    SicBoResult,
    SicBoStatistics,
} from '../../../models/games/sicbo';
import {
    TeenPattiGameState,
    TeenPattiRecord,
    TeenPattiResult,
    TeenPattiStatistics,
} from '../../../models/games/teenpatti';
import {
    UltraRouletteRecord,
    UltraRouletteResult,
} from '../../../models/games/ultraRoulette';
import { BetTypeMaxBet } from '../../../models/host/MaxBet';
import { HostMessage } from '@/models/games/BaseHostMessage';
export type HallColorProps = {
    hallColor: 'aHall' | 'cHall' | 'eHall' | 'mHall' | 'other'; //SA: HostSetting -> hallStateName -> game_config.xml
};
export type SupportedRecord =
    | BaccaratRecord
    | BlackjackRecord
    | DragonTigerRecord
    | PokDengRecord
    | SicBoRecord
    | SedieRecord
    | RouletteRecord
    | UltraRouletteRecord
    | TeenPattiRecord
    | AndarBaharRecord
    | ThaiHiLoRecord
    | FishPrawnCrabRecord
    | Blackjack2Record
    | CarnivalTreasureRecord;
export type SupportedGameResult =
    | BaccaratResult
    | DragonTigerResult
    | PokDengResult
    | SicBoResult
    | BlackjackResult
    | SedieResult
    | AndarBaharResult
    | RouletteResult
    | UltraRouletteResult
    | TeenPattiResult
    | ThaiHiLoResult
    | FishPrawnCrabResult
    | CarnivalTreasureResult;
export type SupportedGoodRoad = BaccaratGoodRoad;
export type SupportedGameStatistics =
    | BaccaratStatistics
    | DragonTigerStatistics
    | PokDengStatistics
    | SicBoStatistics
    | SedieStatistics
    | TeenPattiStatistics
    | AndarBaharStatistics
    | RouletteStatistics
    | ThaiHiLoStatistics
    | FishPrawnCrabStatistics
    | CarnivalTreasureStatistics;
export type SupportedGameState =
    | BaccaratGameState
    | AndarBaharGameState
    | RouletteGameState
    | DragonTigerGameState
    | SicBoGameState
    | TeenPattiGameState
    | ThaiHiLoGameState
    | FishPrawnCrabGameState
    | Blackjack2GameState
    | CommonGameState;
export type SupportedGame = {
    GameID: number;
    OldResult: Array<SupportedGameResult>;
    IsRest: boolean;
    IsPause: boolean;
    IsInited: boolean;
    GameDelay?: GameDelay;
    IsInternalTest: boolean;
};
export type Dealer = {
    DealerId: number;
    DealerName: string;
};
export type BetPlayerAmount = {
    Amount: number;
    BetPlayerCount: number;
};
export type HostInfo = {
    AllowSideBet: boolean;
    HostId: number;
    Rest: number;
    Seat: number;
    Setting: number;
    MaxBet?: Array<BetTypeMaxBet>;
    Multiplier?: number;
};
export type HostConfig = {
    OrderBy: number;
    HallId: number;
    GameType: GameTypeEnum;
    Group: string;
    Video: string;
    Audio: boolean;
    Hls: string;
    Nano: string;
    HostName: string;
    DelayDraw: number;
    DelayResult: number;
    DelayZoom: number;
    enabled: boolean;
    TableLimit: number; //?唔確定係唔係跟game_config
    Time: number;
    Sai?: number;
    ShuffleDelay?: number;
    HallStateName?: HallColorProps['hallColor'];
    IsTest?: boolean;
    ChatEnabled?: boolean;
    GiftEnabled?: boolean;
    tableTheme?: string;
};

export type HostGame = {
    DealerImageRefresh?: string;
    DealerList?: Array<Dealer>;
    Statistics?: SupportedGameStatistics;
    Record?: Array<SupportedRecord>;
    GameCount?: number;
    WinAmount: number;
    GameStateTimer?: Array<[NodeJS.Timeout, number]>;
    IsRestart?: number;
    IsRoundCancel?: boolean;
    CloseMsg?: string;
    HostMessageId?: HostMessage;
};

export type HostTable = HostInfo & HostConfig & HostGame & SupportedGame;
export const initialPHostTable = {} as HostTable;
